/** Preferences owns its state and behavior; dependencies are passed in by main. */

export const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';

export function setPageTheme(mode) {
  const dark = mode === 'dark';
  document.body.classList.toggle('dark-mode', dark);
  document.documentElement.style.colorScheme = mode;
  document.querySelector('meta[name="theme-color"]').content = dark ? '#11110f' : '#f8f6f1';
}

export function register(app) {
  const { preferences, hero, projects } = app;

  preferences.getLangElements = function getLangElements(scope = document) {
    if (!scope) return [];
    const nestedElements = scope.querySelectorAll
      ? Array.from(scope.querySelectorAll('.lang-text'))
      : [];
    if (scope.matches && scope.matches('.lang-text')) return [scope, ...nestedElements];
    return nestedElements;
  };

  preferences.applyTheme = function applyTheme(mode) {
    const darkMode = mode === 'dark';
    setPageTheme(mode);
    if (preferences.themeToggle) {
      const label = darkMode ? 'Prepnúť na svetlý režim' : 'Prepnúť na tmavý režim';
      preferences.themeToggle.setAttribute('title', label);
      preferences.themeToggle.setAttribute('aria-label', label);
      preferences.themeToggle.setAttribute('aria-pressed', String(darkMode));
    }
  };

  preferences.applyLangTextElements = function applyLangTextElements(scope = document) {
    preferences.getLangElements(scope).forEach((el) => {
      const text = el.getAttribute(`data-${preferences.currentLang}`);
      if (text !== null) el.innerHTML = text;
    });
  };

  preferences.setLanguage = function setLanguage() {
    // This site is Slovak-only; an older saved English choice must not translate it.
    preferences.currentLang = 'sk';
    document.documentElement.setAttribute('lang', preferences.currentLang);
    preferences.applyLangTextElements();
    projects.applyProjectCollaboratorLabels();
    projects.applyProjectArchiveLabels();
    hero.renderHeroSlideCopies();
    hero.updateHeroCopy(hero.heroIndex, true);
  };
}

/** Initializers are called explicitly, in dependency order, from main. */
export function initializePreferences(app) {
  const { preferences } = app;
  preferences.themeToggle = document.getElementById('theme-toggle');
  preferences.currentLang = 'sk';
  const scheme = window.matchMedia?.(DARK_SCHEME_QUERY);
  const followBrowser = () => preferences.applyTheme(scheme?.matches ? 'dark' : 'light');
  scheme?.addEventListener('change', followBrowser);
  followBrowser();
  preferences.themeToggle?.addEventListener('click', () => {
    preferences.applyTheme(document.body.classList.contains('dark-mode') ? 'light' : 'dark');
  });
}
